__turbopack_context__.v({
  "body": "quickview-modal-module-scss-module__eVKrIG__body",
  "card": "quickview-modal-module-scss-module__eVKrIG__card",
  "close": "quickview-modal-module-scss-module__eVKrIG__close",
  "content": "quickview-modal-module-scss-module__eVKrIG__content",
  "detailLink": "quickview-modal-module-scss-module__eVKrIG__detailLink",
  "loading": "quickview-modal-module-scss-module__eVKrIG__loading",
  "overlay": "quickview-modal-module-scss-module__eVKrIG__overlay",
  "panelWrap": "quickview-modal-module-scss-module__eVKrIG__panelWrap",
  "qv-shimmer": "quickview-modal-module-scss-module__eVKrIG__qv-shimmer",
  "skelImg": "quickview-modal-module-scss-module__eVKrIG__skelImg",
  "skelLine": "quickview-modal-module-scss-module__eVKrIG__skelLine",
  "skelLines": "quickview-modal-module-scss-module__eVKrIG__skelLines",
});
